type SvgProps = React.SVGProps<SVGSVGElement>;
const Loader = ({ width, height }: Pick<SvgProps, 'width' | 'height'>) => (
  <svg
    width={width}
    height={height}
    aria-labelledby='loading-aria'
    preserveAspectRatio='none'
  >
    <title>{'Loading...'}</title>
    <rect
      width='100%'
      height={'100%'}
      clipPath='url(#a)'
      style={{
        fill: 'url(#b)',
      }}
    />
    <defs>
      <linearGradient id='b'>
        <stop offset={0.6} stopColor='#f3f3f3'>
          <animate
            attributeName='offset'
            dur='2s'
            keyTimes='0; 0.25; 1'
            repeatCount='indefinite'
            values='-2; -2; 1'
          />
        </stop>
        <stop offset={1.6} stopColor='#ecebeb'>
          <animate
            attributeName='offset'
            dur='2s'
            keyTimes='0; 0.25; 1'
            repeatCount='indefinite'
            values='-1; -1; 2'
          />
        </stop>
        <stop offset={2.6} stopColor='#f3f3f3'>
          <animate
            attributeName='offset'
            dur='2s'
            keyTimes='0; 0.25; 1'
            repeatCount='indefinite'
            values='0; 0; 3'
          />
        </stop>
      </linearGradient>
      <clipPath id='a'>
        <rect width={'100%'} height={'100%'} x={0} y={0} rx={3} ry={3} />
      </clipPath>
    </defs>
  </svg>
);

export default Loader;
